import React from "react";
import AnswerRadioGroup from "./AnswerRadioGroup";
import AnswerFile from "./AnswerFile";

const Caption = ({ children }) => (
  <div className="text-[11px] uppercase tracking-wide text-gray-500 mb-1.5">{children}</div>
);

const splitMultiValue = (value) =>
  String(value ?? "")
    .split(";")
    .map((p) => p.trim())
    .filter(Boolean);

// Every labeled answer field a custom question defines, with its template label
// and the field's own options — matching the Excel/PDF export field set. The
// file slot shows the question's attachment list; text slots show the recorded
// text (or the empty state).
const AnswerSlots = ({ slots, attachments }) => {
  const list = Array.isArray(slots) ? slots : [];
  if (list.length === 0) return null;

  const ordered = [...list].sort((a, b) => {
    const rank = (s) =>
      s.schema === "select" || s.schema === "multiselect" ? 0 : s.schema === "file" ? 1 : 2;
    return rank(a) - rank(b) || (a.index ?? 0) - (b.index ?? 0);
  });

  return (
    <div className="space-y-3">
      {ordered.map((slot) => {
        const key = `slot-${slot.index}`;
        switch (slot.schema) {
          case "select":
            return (
              <div key={key}>
                <Caption>{slot.title}</Caption>
                <AnswerRadioGroup options={slot.options} values={slot.value} />
              </div>
            );
          case "multiselect":
            return (
              <div key={key}>
                <Caption>{slot.title}</Caption>
                <AnswerRadioGroup
                  options={slot.options}
                  values={splitMultiValue(slot.value)}
                  multi
                />
              </div>
            );
          case "file":
            return (
              <div key={key}>
                <Caption>{slot.title}</Caption>
                <AnswerFile attachments={attachments} />
              </div>
            );
          default:
            return (
              <div key={key}>
                <Caption>{slot.title}</Caption>
                {slot.value ? (
                  <p className="text-sm text-gray-800 bg-white border border-emerald-100 rounded-md p-3 whitespace-pre-wrap">
                    {slot.value}
                  </p>
                ) : (
                  <p className="text-sm italic text-gray-400">No response</p>
                )}
              </div>
            );
        }
      })}
    </div>
  );
};

export default AnswerSlots;
